import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { hash } from '@ember/helper';
import { HdsAlert } from '@hashicorp/design-system-components/components';
import HcpAlertTerraformPermissionsGoToTerraform from 'hcp/components/hcp/alert/terraform-permissions/go-to-terraform';

export default class HcpAlertTerraformPermissions extends Component {
  @service userContext;

  /** @type {boolean} */
  @tracked bannerDismissed = false;

  get showBanner() {
    return !this.bannerDismissed;
  }

  onDismiss = () => {
    this.bannerDismissed = true;
  };

  <template>
    {{#if this.userContext.organizationMeta.unifiedExperienceEnabled}}
      {{#if this.showBanner}}
        <HdsAlert
          @type="inline"
          @color="neutral"
          @icon="terraform"
          @onDismiss={{this.onDismiss}}
          data-test-projects-terraform-permissions-alert
          as |A|
        >
          <A.Title>
            {{t
              "components.hcp.alert.terraform-permissions.looking-for-header"
            }}
          </A.Title>
          <A.Description>
            {{t
              "components.hcp.alert.terraform-permissions.looking-for-description"
            }}
          </A.Description>
          <A.Generic>
            {{yield
              (hash GoToTerraform=HcpAlertTerraformPermissionsGoToTerraform)
            }}
          </A.Generic>
        </HdsAlert>
      {{/if}}
    {{/if}}
  </template>
}
